/**
 * NotesSection - Notes field wrapper
 *
 * Wraps existing NotesField component for consistent styling
 */

import { useTranslation } from "react-i18next";
import React from "react";
import { UseFormReturn } from "react-hook-form";
import { NotesField } from "@/components/quotes/NotesField";
import { QuoteFormData, TemplateFormData } from "../index";

interface NotesSectionProps {
  form: UseFormReturn<QuoteFormData | TemplateFormData>;
}

export const NotesSection: React.FC<NotesSectionProps> = ({ form }) => {
  const { t } = useTranslation();
  return (
    <div className="border-t pt-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">{t("features.quotes.quoteEditor.sections.notesSection.notes")}</h3>
      <NotesField
        form={form}
        fieldName="notes"
        placeholder={t("features.quotes.quoteEditor.sections.notesSection.enterNotesForThis")}
      />
    </div>
  );
};
